export const CONTACT_FORM_REQUEST = "CONTACT_FORM_REQUEST";
export const CONTACT_FORM_SUCCESS = "CONTACT_FORM_SUCCESS";
export const CONTACT_FORM_FAIL = "CONTACT_FORM_FAIL";


export const CLEAR_ERRORS = "CLEAR_ERRORS";